import React, {useState, useEffect, useMemo} from 'react';
import { Pressable, ScrollView, View } from 'react-native'

import tw from '../../styles/tailwind';
import Text from '../../components/Text';
import Icon from '../../components/IcomoonIcon';


import { actions } from '../../store/Reducers/auth';
import Constants from 'expo-constants'
import { useDispatch, useSelector } from 'react-redux';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Image } from 'expo-image';
import useActiveAdminCommunity from '../../hooks/useActiveAdminCommunity';
import useStaff from '../../hooks/useStaff';



export default function AdminCommunitiesScreen({navigation}) {
  const { global_roles } = useSelector(state => state.status)
  const { setActiveCommunityId } = useActiveAdminCommunity()

  const { adminCommunities: admin_communities, guardCommunities } = useStaff()
  const vinte_global_roles = useMemo(() => global_roles?.filter(role => role.name == "vinte_despacho" || role.name == "vinte_corporativo_posventa"), [global_roles])
  const isSuperAdmin = useMemo(() => (global_roles?.some((r: any) => r.name === 'super_admin')), [global_roles])



  return (
    <SafeAreaView style={tw`flex-1 py-4 pb-16`}>
      <ScrollView style={tw`flex-1`}>
        {
          admin_communities?.length > 0 &&
            <View>
              <Text style={tw`text-lg mb-4 px-5`}>Mis comunidades</Text>
              {/* <Text style={tw`text-center text-gray-400`}>{state.user?.email}</Text> */}

              {
                admin_communities?.map(community => 
                  <View key={community.uuid}>
                    <Pressable
                      style={
                        ({ pressed }) => tw.style(`bg-white rounded-2xl border border-gray-200 row justify-between py-3 px-4 mx-4 mb-4`, pressed && `opacity-50`)
                      }
                      onPress={() => {
                        setActiveCommunityId(community.uuid)

                        navigation.navigate('Admin.Dashboard', {
                          screen: "Home",
                          params: {
                            communityId: community.uuid,
                          }
                        })
                      }}
                    >
                      <View style={tw`row`}>
                        <View style={tw`rounded-lg mr-3 w-16 h-16 bg-white overflow-hidden`}>
                          <Image style={tw`w-full h-full`} source={community?.image_path} />
                        </View>

                        <Text style={tw`text-secondary font-500`}>{community.name}</Text>
                      </View>
                      <Icon name='chevron-right' color={tw.color('secondary')} />
                    </Pressable>
                  </View>
                )
              }
            </View>
        }


        {
          guardCommunities.length > 0 &&
            <View style={tw.style(admin_communities?.length > 0 && `mt-6`)}>
              <Text style={tw`text-lg mb-4 px-5`}>Consola de vigilancia</Text>
              {
                guardCommunities.map(community =>
                  <Pressable
                    key={community.uuid}
                    style={({ pressed }) => tw.style(`row bg-white rounded-2xl border border-gray-200 py-3 px-4 mx-4 mb-4`, pressed && `opacity-50`)}
                    onPress={() => navigation.navigate('Guard.Stack', { communityId: community.uuid })}
                  >
                    <View style={tw`flex-1`}>
                      <Text style={tw`text-gray-700 font-600`}>{community.name}</Text>
                      <Text style={tw`text-gray-500`}>Registro, accesos y bitácora</Text>
                    </View>

                    <Ionicons name="shield-outline" size={20} color={tw.color('gray-700')} style={tw`mr-2`} />
                  </Pressable>
                )
              }
            </View>
        }


        {
          vinte_global_roles?.length > 0 &&
            <View style={tw`mt-6`}>
              <Text style={tw`text-lg mb-4 px-5`}>Administración Vinte</Text>
              <Pressable
                style={({ pressed }) => tw.style(`row bg-white rounded-2xl border border-gray-200 py-3 px-4 mx-4 mb-4`, pressed && `opacity-50`)}
                onPress={() => navigation.navigate('Vinte.Home', { params: {} })}
              >
                <View style={tw`flex-1`}>
                  <Text style={tw`text-gray-700 font-600`}>Panel Vinte</Text>
                  <Text style={tw`text-gray-500`}>Solicitudes y administración Vinte</Text>
                </View>

                <Ionicons name="business-outline" size={20} color={tw.color('gray-700')} style={tw`mr-2`} />
              </Pressable>
            </View>
        }

        {
           isSuperAdmin &&
            <View style={tw`mt-6`}>
              <Text style={tw`text-lg mb-4 px-5`}>Administración DingDong</Text>
              <Pressable
                style={({ pressed }) => tw.style(`row bg-yellow-100 rounded-2xl border border-gray-200 py-3 px-4 mx-4 mb-4`, pressed && `opacity-50`)}
                onPress={() => navigation.navigate('MetaAdmin.Stack')}
              >
                <View style={tw`flex-1`}>
                  <Text style={tw`text-gray-700 font-600`}>Meta Admin</Text>
                  <Text style={tw`text-gray-500`}>Panel interno modo dios.</Text>
                </View>

                <Ionicons name="shield-checkmark-outline" size={20} color={tw.color('gray-700')} style={tw`mr-2`} />
              </Pressable>
            </View>
        }
      </ScrollView>
    </SafeAreaView>

  );
}
